module.exports = __webpack_public_path__ + "57da825349f57d7ebd5a9dd4832b44db.svg";